import className from 'classnames';
import fp from 'lodash/fp';
import React from 'react';
import { Button } from 'react-bootstrap';
import connect from 'react-redux/lib/connect/connect';
import { withHandlers, withProps, withStateHandlers } from 'recompose';
import { bindActionCreators, compose } from 'redux';
import { PublisherStatus } from '../../../../../constants/publisher';
import { adminActions } from '../../../../../state/modules/admin';
import { Icon } from '../../../../components';
import { LinkContainer } from 'react-router-bootstrap';
import { routes } from '../../../../../constants';

const PublisherTableFields = {
  title: {
    title: 'Title',
    field: 'title',
    sortable: true
  },
  activeItemCount: {
    title: 'Active Item Count',
    field: 'activeItemCount',
    sortable: true
  },
  created_time: {
    title: 'Created Time',
    field: 'createdTime',
    sortable: true
  },
  actions: {
    title: 'Actions',
    field: 'actions',
    sortable: false
  },
  operations: {
    title: 'Operations',
    field: 'operations',
    sortable: false
  }
}

const PublisherTable = ({
  sortedPublishers,
  sortOrder,
  sortPublishers,
  renderSortingArrow,
  updatePublisher
}) => (
    <table className={className('table--admin-publisher', className)}>
      <thead>
        <tr>
          {
            fp.map((heading) =>
              <td key={heading.field} className={heading.field}>
                {
                  heading.sortable ?
                    <Button onClick={() => sortPublishers(heading.field, sortOrder[heading.field])} className='heading-btn' bsStyle='plain'>
                      {heading.title} &nbsp;
                      {
                        renderSortingArrow(heading.field)
                      }
                    </Button> : <div>{heading.title}</div>
                }
              </td>
            )(PublisherTableFields)
          }
        </tr>
      </thead>
      <tbody>
        {
          fp.map((publisher) => (
            <tr key={publisher.id}>
              <td className='title'>{publisher.title}</td>
              <td className='activeItemCount'>{publisher.activeItemCount}</td>
              <td className='createdTime'>{publisher.createdTime}</td>
              <td className='edit-row'>
              <LinkContainer to={{ pathname: routes.adminPortal.publisherEdit(publisher.id) }}>
                <Button bsStyle='plain'><Icon icon='edit-medium' /> Edit</Button>
              </LinkContainer>
              </td>
              <td className='operations'>
                <Button bsStyle='plain' className='warning' onClick={() => updatePublisher(publisher.id, {
                  data: {
                    name: publisher.title,
                    status: publisher.status === PublisherStatus.active ? PublisherStatus.archived : PublisherStatus.active
                  },
                  file: []
                })}>
                  {publisher.status === PublisherStatus.active ? "Archive" : "Active"}
                </Button> 
              </td>
            </tr>
          ))(sortedPublishers)
        }
      </tbody>
    </table>
  );

const mapStateToProps = (state) => ({})

const mapDispatchToProps = (dispatch) => ({
  updatePublisher: bindActionCreators(adminActions.admin.updatePublisher, dispatch)
})

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withProps(({ publishersResult }) => ({
    publishers: fp.map((publisher) => ({
      id: publisher.id,
      title: publisher.name,
      activeItemCount: publisher.activeItemCount,
      status: publisher.status,
      createdTime: publisher.metaData.dateCreated
    }))(publishersResult)
  })),
  withStateHandlers(({ publishers }) => ({
    sortedPublishers: fp.sortBy(publisher => publisher.title)(publishers),
    sortOrder: {}
  }), {
      sortPublishers: ({ sortedPublishers }, { publishers }) => (field, sortOrder) => {
        var nextSortOrder = sortOrder ? sortOrder === 'asc' ? 'desc' : undefined : 'asc'
        return {
          sortedPublishers: nextSortOrder ? fp.orderBy([field], [nextSortOrder])(sortedPublishers) : publishers,
          sortOrder: { [field]: nextSortOrder }
        }
      }
    }),
  withHandlers({
    renderSortingArrow: ({ sortOrder }) => (field) => {
      if (sortOrder[field] === 'asc') {
        return <Icon icon='arrow-up-medium' />;
      }
      else if (sortOrder[field] === 'desc') {
        return <Icon icon='arrow-down-medium' />;
      }
      else {
        return <span><Icon icon='arrow-down-medium' /><Icon icon='arrow-up-medium' /></span>
      }
    }
  })
)(PublisherTable)


// WEBPACK FOOTER //
// ./src/containers/pages/admin-portal/publisher-portal/partials/publisherTable.js